<template>
  <div class="designs" v-loading="isLoading">
    <div class="posters">
      <div class="card-item poster-long" v-for="poster of posterList" :key="poster.id">
        <div class="poster-long-container">
          <poster-long
            class="design-poster"
            ref="posterDom"
            :size="poster.size"
            :elConfig="poster.elementInfo"
            :bgConfig="poster.bgParameter"
            :elementImg="poster.elementImg"
            :textInfo="poster.textInfo"
            :contentStyle="poster.contentStyle"
            :posterTextMaps="poster.posterTextMaps"
            :portraitInfo="poster.portraitInfo"
            :logo="poster.logo"
          />
        </div>
        <span class="save-time"> 保存于: {{ filterTime(poster.time) }} </span>
        <div class="mask">
          <span class="btn" @click="toDesignDetail(poster.schemeId)"> <i class="el-icon-edit"></i>编辑 </span>
          <span class="btn" @click="delectConfirm(poster.schemeId)"><i class="el-icon-delete"></i>删除</span>
        </div>
        <div class="caption">
          <span class="count">共计 {{ poster.logos && poster.logos.length }} 张海报</span>
          <dropdown v-if="!userId" :designName="'poster'" :designData="poster"></dropdown>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        v-if="totalPage"
        :key="2"
        background
        layout="prev, pager, next"
        :page-count="totalPage"
        @current-change="getDesginList"
        @prev-click="getDesginList(--pageIndex)"
        @next-click="getDesginList(++pageIndex)"
      />
    </div>
    <div class="nothing" v-if="!posterList.length">
      <span class="tips">您还没有添加内容，赶紧去添加吧</span>
      <button class="btn" @click="navigateBack">开始创意</button>
    </div>
    <el-dialog title="提示" :visible.sync="delectDialogVisible" top="25vh" width="400px" left>
      <span class="msg"><i class="iconfont icon-jingshi"></i>是否删除当前文件？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="immediateDelete(currentDesign)">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dropdown from "@/components/dropdown.vue";
import posterLong from "@/pages/poster/components/poster-long.vue";
import { getContentStyles, getLogos, getPosterList, deletePoster } from "@/pages/poster/js/poster-feature";
import { randomItemOfArr } from "@/assets/scripts/common.js";
export default {
  name: "posterList",
  props: {
    userId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      posterList: [],
      delectDialogVisible: false,
      currentDesign: "",
      totalPage: 0,
      pageSize: 20,
      pageIndex: 1,
      isLoading: false,
      // 内容区域的样式列表
      contentStyles: [],
      // 业务线logo
      logoOptions: [],
    };
  },
  components: {
    dropdown,
    posterLong,
  },
  async mounted() {
    this.logoOptions = await getLogos();
    this.contentStyles = await getContentStyles();
    await this.getDesginList(1);
  },
  methods: {
    async getDesginList(pageIndex) {
      if (!this.isLoading) false;
      this.isLoading = true;
      const params = {
        pageSize: this.pageSize,
        pageIndex,
      };
      if (this.userId) {
        params.userId = this.userId;
      }
      let data = await getPosterList(params);
      this.isLoading = false;
      if (!data.list) return;
      data.list.forEach(element => {
        const logoIds = element.logos.split(",");
        element.logos = logoIds;
        element.logo = this.logoOptions.find(logo => logo.id === parseInt(logoIds[0]));
        element.contentStyle =
          this.contentStyles.find(item => item.id === element.contentStyleId) || randomItemOfArr(this.contentStyles);
      });
      this.posterList = data.list;
      this.pageIndex = data.pageIndex;
      this.totalPage = data.totalPage;
      // 设置海报缩放
      this.setPosterScale();
    },
    toDesignDetail(schemeId) {
      if (this.userId) {
        this.$emit("toDesignDetail", schemeId);
      } else {
        this.$router.push({
          path: "/poster/logo-choice",
          query: { schemeId },
        });
      }
    },
    delectConfirm(id) {
      this.currentDesign = id;
      this.delectDialogVisible = true;
    },
    async immediateDelete(id) {
      let data = await deletePoster(id, this.userId);
      if (data.status) {
        this.pageIndex = 1;
        this.getDesginList(this.pageIndex);
      }
      this.delectDialogVisible = false;
    },
    filterTime(timeStamp) {
      const creatTime = new Date(timeStamp);
      const year = creatTime.getFullYear();
      const month = creatTime.getMonth() + 1;
      const day = creatTime.getDate();
      return `${year}.${month < 10 ? `0${month}` : month}.${day < 10 ? `0${day}` : day}`;
    },
    navigateBack() {
      this.$store.commit("poster/clearPosterCacheInfo");
      this.$router.push({
        path: "/poster/build?rebuild=true",
      });
    },
    // 设置海报缩放
    setPosterScale() {
      this.$nextTick(() => {
        const targetHeight = 667;
        if (!this.posterList.length) return;
        this.$refs.posterDom.forEach(poster => {
          const originalHeight = poster.$el.offsetHeight;
          let scaleFactor = 1;
          if (originalHeight > targetHeight) {
            scaleFactor = targetHeight / originalHeight;
            // Math.round((targetHeight / originalHeight) * 100) / 100;
          }
          poster.$el.style.transform = `scale(${scaleFactor})`;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.designs {
  position: relative;
  height: calc(100vh - 166px);
  .posters {
    display: grid;
    grid-template-columns: repeat(auto-fit, 399px);
    justify-content: center;
    align-content: flex-start;
    padding: 15px;
    gap: 24px;
    position: relative;
    overflow: auto;
    height: calc(100% - 50px);
    .card-item {
      position: relative;
      box-sizing: border-box;
      padding: 12px 12px 44px;
      background-color: #fff;
      border-radius: 12px;
      width: 399px;
      height: 724px;
      &:before {
        position: absolute;
        content: "";
        left: 12px;
        right: 12px;
        top: 12px;
        bottom: 44px;
        z-index: 1;
        background: #ededed;
      }
      .poster-long-container {
        overflow: hidden;
        width: 100%;
        height: 668px;
      }
      .design-poster {
        z-index: 2;
        transform-origin: center 0;
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: right;
    padding: 15px;
  }
  @include scroller;
}
.flip-list-enter-active {
  transition: all 0.5s;
}
.flip-list-leave-active {
  position: absolute;
}
.flip-list-enter {
  opacity: 0;
  transform: scale(0.8);
}
.flip-list-leave-to {
  height: 0;
}
</style>
